import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Form from './FormForm';
import { closeCustomDialogAction } from 'redux/slices/customDialogSlice';
import { updateFormAction } from 'redux/slices/formSlice';

const FormEdit = ({ form, onSubmit, onCancel }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const handleSubmit = ({ data, onSuccess, onFailure }) => {
        dispatch(
            updateFormAction({
                id: form.id,
                data: data,
                onSuccess: (response) => {
                    if (onSubmit) {
                        try {
                            onSubmit(response);
                        } catch (e) {
                            console.error(`Error executing form edit submit callback: ${e.message}`);
                        }
                    }
                    onSuccess(response);
                    dispatch(closeCustomDialogAction());
                },
                onFailure,
            }));
    };
    
    const handleClose = () => {
        if (onCancel) {
            try {
                onCancel();
            } catch (e) {
                console.error(`Error executing form edit cancel callback: ${e.message}`);
            }
        }
        dispatch(closeCustomDialogAction());
    }
    
    return (
        <Form
            action={t('form.formEdit.edit')}
            form={form}
            onSubmit={handleSubmit}
            close={handleClose}
        />
    );
};

export default FormEdit;